export const APP_BAR_TOOLBAR_HEIGHT = 60 as const;
